var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgDiscount = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "fill",
    width: 29,
    height: 30.223,
    viewBox: "0 0 29 30.223",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.961,15.5a.886.886,0,0,1,0-.783l1.127-2.306a2.624,2.624,0,0,0-1.132-3.484l-2.267-1.2a.886.886,0,0,1-.46-.633l-.443-2.528A2.624,2.624,0,0,0,31.821,2.41L29.28,2.77a.886.886,0,0,1-.745-.242L26.691.743a2.624,2.624,0,0,0-3.663,0L21.183,2.528a.886.886,0,0,1-.745.242L17.9,2.411a2.623,2.623,0,0,0-2.964,2.153L14.49,7.092a.886.886,0,0,1-.46.633l-2.267,1.2a2.624,2.624,0,0,0-1.132,3.484l1.127,2.306a.886.886,0,0,1,0,.783L10.63,17.807a2.624,2.624,0,0,0,1.132,3.484l2.267,1.2a.886.886,0,0,1,.46.633l.443,2.528a2.622,2.622,0,0,0,2.586,2.18,2.7,2.7,0,0,0,.377-.027l2.541-.359a.885.885,0,0,1,.745.242l1.845,1.785a2.624,2.624,0,0,0,3.663,0l1.845-1.785a.887.887,0,0,1,.745-.242l2.541.359a2.623,2.623,0,0,0,2.964-2.153l.443-2.528a.886.886,0,0,1,.46-.633l2.267-1.2a2.624,2.624,0,0,0,1.132-3.484Zm-.822,4.25-2.267,1.2a2.618,2.618,0,0,0-1.36,1.872l-.443,2.528a.888.888,0,0,1-1,.729l-2.541-.359a2.617,2.617,0,0,0-2.2.715l-1.845,1.784a.888.888,0,0,1-1.239,0l-1.845-1.785a2.615,2.615,0,0,0-1.826-.742,2.676,2.676,0,0,0-.375.027l-2.541.359a.888.888,0,0,1-1-.729l-.443-2.528a2.617,2.617,0,0,0-1.36-1.872l-2.267-1.2a.888.888,0,0,1-.383-1.179l1.127-2.306a2.618,2.618,0,0,0,0-2.314L12.2,11.647a.888.888,0,0,1,.383-1.179l2.267-1.2a2.618,2.618,0,0,0,1.36-1.872l.443-2.528a.888.888,0,0,1,1-.729l2.541.359a2.618,2.618,0,0,0,2.2-.715L24.239,2a.888.888,0,0,1,1.239,0l1.845,1.785a2.617,2.617,0,0,0,2.2.715l2.541-.359a.888.888,0,0,1,1,.729l.443,2.528a2.617,2.617,0,0,0,1.36,1.872l2.267,1.2a.888.888,0,0,1,.383,1.179l-1.127,2.306a2.618,2.618,0,0,0,0,2.314l1.127,2.306A.888.888,0,0,1,37.139,19.751Z",
    transform: "translate(-10.359 0.002)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.876 8.488)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.783,144.047a.872.872,0,0,0-1.233,0l-11.5,11.5a.872.872,0,1,0,1.233,1.233l11.5-11.5A.871.871,0,0,0,156.783,144.047Z",
    transform: "translate(-143.792 -143.792)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.818 7.267)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M146,123.116a3.2,3.2,0,1,0,3.2,3.2A3.2,3.2,0,0,0,146,123.116Zm0,4.648a1.453,1.453,0,1,1,1.453-1.453A1.454,1.454,0,0,1,146,127.764Z",
    transform: "translate(-142.802 -123.116)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.79 16.564)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.118,280.61a3.2,3.2,0,1,0,3.2,3.2A3.2,3.2,0,0,0,264.118,280.61Zm0,4.648a1.453,1.453,0,1,1,1.453-1.453A1.454,1.454,0,0,1,264.118,285.258Z",
    transform: "translate(-260.922 -280.61)",
    fill: "#fff"
  })))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDiscount, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/discount.9e7e6849.svg";
export { ForwardRef as ReactComponent };